<template>
  <AppModalEdit
    v-model="isActive"
    :show-exec-button="false"
    :confirm-on-click-cancel="false"
    cancel-button-text="閉じる"
    title="申請内容"
    width="50vw"
    min-height="36vh"
  >
    <v-container v-if="isActive" grid-list-md>
      <v-layout wrap>
        <v-flex xs2>
          <h4>メニュー名</h4>
        </v-flex>
        <v-flex xs10>
          {{ request.name }}
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs2>
          <h4>課金形態</h4>
        </v-flex>
        <v-flex xs10>
          <UnitType :value="request.unitType" />
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs2>
          <h4>配信単価</h4>
        </v-flex>
        <v-flex xs10>
          {{ request.unitPriceString }}
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs2>
          <h4>使用可能範囲</h4>
        </v-flex>
        <v-flex xs10>
          <ResourceType :value="request.resourceType" />
          {{ request.resourceName }}
        </v-flex>
      </v-layout>
      <v-layout v-if="request.isRejected" wrap>
        <v-flex xs2>
          <h4>却下理由</h4>
        </v-flex>
        <v-flex xs10 style="white-space: pre-wrap">{{ request.reason }}</v-flex>
      </v-layout>
    </v-container>
  </AppModalEdit>
</template>

<script>
import UnitType from '../../Shared/Presentation/Menu/UnitType.vue'
import ResourceType from '../../Shared/Presentation/ResourceType.vue'
export default {
  components: { ResourceType, UnitType },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    request() {
      return this.item.latestRequest
    },
  },
}
</script>

<style scoped></style>
